import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { EASE } from "./Reveal";

export const Nav = ({ t, lang, setLang }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const links = [
    { id: "work", label: t.nav.work },
    { id: "process", label: t.nav.process },
    { id: "founder", label: t.nav.founder },
    { id: "contact", label: t.nav.contact },
  ];
  const go = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: EASE, delay: 0.6 }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-cream/70 border-b border-ink/[0.06]"
      data-testid="main-nav"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="font-serif text-xl md:text-2xl tracking-[0.18em] text-ink" data-testid="nav-logo">
          ANKLA
        </button>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="font-sans text-[11px] uppercase tracking-[0.25em] text-ink/60 hover:text-ink transition-colors duration-500"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 font-sans text-[11px] tracking-[0.2em]" data-testid="lang-toggle">
            {["en", "es"].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                data-testid={`lang-${l}`}
                className={`px-2.5 py-1.5 uppercase transition-colors duration-500 ${lang === l ? "bg-ink text-cream" : "text-ink/50 hover:text-ink"}`}
              >
                {l}
              </button>
            ))}
          </div>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
            data-testid="mobile-menu-button"
            className="md:hidden w-11 h-11 flex items-center justify-center text-ink"
          >
            {menuOpen ? <X size={20} strokeWidth={1.5} /> : <Menu size={20} strokeWidth={1.5} />}
          </button>
        </div>
      </div>
    </motion.header>
    <AnimatePresence>
      {menuOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="fixed inset-x-0 top-16 bottom-0 z-40 bg-cream md:hidden overflow-y-auto"
          data-testid="mobile-menu"
        >
          <nav className="flex flex-col px-6 pt-8 pb-12">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`mobile-nav-link-${l.id}`}
                className="text-left font-serif text-4xl text-ink py-5 border-b border-ink/10"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </motion.div>
      )}
    </AnimatePresence>
    </>
  );
};
